// extracted by mini-css-extract-plugin
export default {"node-minimal":"lsf-node-minimal","node-minimal__counter":"lsf-node-minimal__counter","node-minimal__icon":"lsf-node-minimal__icon"};
    if(module.hot) {
      // 1732531523407
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  